import { Fragment } from "react"
import { cn } from "@/lib/utils"
import { ChevronRight } from "lucide-react"
import { Link } from "react-router-dom"

import type { BreadcrumbItem } from "../types"

interface AdminBreadcrumbsProps {
  items: BreadcrumbItem[]
  className?: string
}

/**
 * Componente de breadcrumbs para navegação administrativa
 */
export function AdminBreadcrumbs({ items, className }: AdminBreadcrumbsProps) {
  if (items.length === 0) {
    return null
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className={cn("text-muted-foreground flex items-center space-x-1 text-sm", className)}
    >
      {items.map((item, index) => (
        <Fragment key={index}>
          {index > 0 && <ChevronRight className="h-4 w-4 shrink-0" />}

          {item.href && !item.isActive ? (
            <Link to={item.href} className="hover:text-foreground transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className={cn(item.isActive && "text-foreground font-medium")}>{item.label}</span>
          )}
        </Fragment>
      ))}
    </nav>
  )
}
